export const videoTypes = {
  avi: {
    mediaTypes: ['video/avi', 'video/msvideo', 'video/x-msvideo'],
    filenameExtension: '.avi',
  },
  mp4: {
    mediaTypes: ['video/mp4'],
    filenameExtension: '.mp4',
  },
  mov: {
    mediaTypes: ['video/quicktime'],
    filenameExtension: '.mov', // .qt 也是 quickTime 文件的扩展名，但是这里只使用一种
  },
  flv: {
    // Windows /Chrome 下 input 标签的 accept 属性不支持 video/x-flv，要使用 .flv 替代，正确的 MIME 类型时 x-flv
    mediaTypes: ['video/x-flv'],
    filenameExtension: '.flv',
  },
  mkv: {
    mediaTypes: ['video/x-matroska'],
    filenameExtension: '.mkv',
  },
  webm: {
    mediaTypes: ['video/webm'],
    filenameExtension: '.webm',
  },
}

export const radioTypes = {
  mp3: {
    mediaTypes: ['audio/mp3', 'audio/mpeg', 'audio/MPA', 'audio/mpa-robust'],
    filenameExtension: '.mp3',
  },
  wav: {
    mediaTypes: ['audio/wav', 'audio/wave', 'audio/x-wav'],
    filenameExtension: '.wav',
  },
  ogg: {
    mediaTypes: ['audio/ogg', 'application/ogg'],
    filenameExtension: '.ogg',
  },
  aac: {
    mediaTypes: ['audio/aac'],
    filenameExtension: '.aac',
  },
}

export const imageTypes = {
  jpg: {
    mediaTypes: ['image/jpeg'],
    filenameExtension: '.jpg',
  },
  jpeg: {
    mediaTypes: ['image/jpeg'],
    filenameExtension: '.jpeg',
  },
  png: {
    mediaTypes: ['image/png'],
    filenameExtension: '.png',
  },
  gif: {
    mediaTypes: ['image/gif'],
    filenameExtension: '.gif',
  },
  webp: {
    mediaTypes: ['image/webp'],
    filenameExtension: '.webp',
  },
  bmp: {
    mediaTypes: ['image/bmp'],
    filenameExtension: '.bmp',
  },
  svg: {
    mediaTypes: ['image/svg+xml'],
    filenameExtension: '.svg',
  },
}

export const archiveTypes = {
  zip: {
    mediaTypes: [
      'application/zip',
      'application/x-zip',
      'application/x-zip-compressed',
      'application/octet-stream',
    ],
    filenameExtension: '.zip',
  },
  html: {
    mediaTypes: ['text/html'],
    filenameExtension: '.html',
  },
  psd: {
    mediaTypes: ['image/vnd.adobe.photoshop'],
    filenameExtension: '.psd',
  },
}

export const fontTypes = {
  // 由于字体没有有效的MIME，直接用文件扩展名
  ttf: {
    mediaTypes: ['.ttf'],
    filenameExtension: '.ttf',
  },
  otf: {
    mediaTypes: ['.otf'],
    filenameExtension: '.otf',
  },
}

export const subtitleTypes = {
  srt: {
    mediaTypes: ['.srt'],
    filenameExtension: '.srt',
  },
  ass: {
    mediaTypes: ['.ass'],
    filenameExtension: '.ass',
  },
}

export default {
  ...imageTypes,
  ...videoTypes,
  ...radioTypes,
  ...archiveTypes,
  ...fontTypes,
  ...subtitleTypes,
}
